document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.w-dropdown[data-dropdown-trigger]');

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('.w-dropdown-toggle');
    const list = dropdown.querySelector('.w-dropdown-list');
    const triggerType = dropdown.dataset.dropdownTrigger;

    if (!trigger || !list) return;

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        list.classList.remove('w--open');
      }
    });

    // Handle hover trigger
    if (triggerType === 'hover') {
      dropdown.addEventListener('mouseenter', () => {
        list.classList.add('w--open');
      });

      dropdown.addEventListener('mouseleave', () => {
        list.classList.remove('w--open');
      });
    }

    // Handle click trigger
    if (triggerType === 'click') {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        list.classList.toggle('w--open');
      });
    }

    // Close dropdown when pressing Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && list.classList.contains('w--open')) {
        list.classList.remove('w--open');
      }
    });
  });
}); 